import cx from 'classnames'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'

import { ReactComponent as CommentIcon } from 'assets/icons/comment24.svg'
import { Button } from 'components/Button'
import { ButtonProps } from 'components/Button/Types'

import { useRootStore } from 'stores/RootStore'
import { useMobileToolbar } from '../stores/MobileToolbarStore'
import { TopTiers } from '../Types'

import MStyles from '../MobileToolbar.module.scss'
import Styles from './CommentButton.module.scss'

export const CommentButton = observer((props: ButtonProps) => {
  const mobileToolbarStore = useMobileToolbar()
  const isSelected = computed(() => mobileToolbarStore.topTier === TopTiers.Comments).get()

  return (
    <Button
      preventFocusOnPress
      variant="none"
      size="sm"
      className={cx(MStyles.button, Styles.button, {
        [MStyles.buttonSelected]: isSelected,
      })}
      {...props}
    >
      <CommentIcon />
      <ActivityIndicator />
    </Button>
  )
})

const ActivityIndicator = observer(() => {
  const { docStore } = useRootStore()

  const hasComments = computed(() => (docStore?.comments?.length ?? 0) > 0).get()
  if (!hasComments) {
    return null
  }

  return <div className={Styles.activityIndicator}>&nbsp;</div>
})
